"use client"

import { faBars } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button } from "antd"
import DrawerSideBar, { DrawerSideBarRef } from "./DrawerSideBar"
import { FC, useRef } from "react"
import { TypeCategory, TypeStoreDetail } from "@/lib/redux/features/store/type"

type ButtonSideBarProps = {
  store: TypeStoreDetail,
  categories: TypeCategory[]
}

const ButtonSideBar: FC<ButtonSideBarProps> = (props) => {
  const refDrawerSideBar = useRef<DrawerSideBarRef>(null)

  return (
    <>
    <DrawerSideBar {...props} ref={refDrawerSideBar} />
    <Button
      aria-label="open side bar mobile"
      type="text"
      className="basic_layout--header__btn"
      icon={<FontAwesomeIcon icon={faBars} />}
      style={{ fontSize: '2.5rem', fontWeight: 'bold', height: "5rem" }}
      size="large"
      htmlType="button"
      styles={{
        icon: {
          alignItems: 'center',
          display: 'flex'
        }
      }}
      onClick={() => refDrawerSideBar.current?.open()}
    />
    </>
  )
}

export default ButtonSideBar